import { render, staticRenderFns } from "./DemoTargetBuilder.vue?vue&type=template&id=6a3ef0f4&"
import script from "./DemoTargetBuilder.vue?vue&type=script&lang=ts&"
export * from "./DemoTargetBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./DemoTargetBuilder.vue?vue&type=style&index=0&id=6a3ef0f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports